import { VEpgGrid, VEpgList } from '@/index/shared/components';

export default {
  components: {
    VEpgGrid,
    VEpgList,
  },
  inject: ['$section'],
  data() {
    return {
      opts: {},
      categories: this.$services.resolve('categories'),
    };
  },
  computed: {
    availableCategories() {
      return this.categories.collection.records.filter((category) => category.label === this.$route.params.label);
    },
    layout() {
      if (this.$window.isMobileView) {
        return VEpgList;
      }

      return VEpgGrid;
    },
  },
};
